module.exports = __webpack_public_path__ + "img/towncenter64_ua.ce227908.webp";